import { render, staticRenderFns } from "./PlaceOrderPro.vue?vue&type=template&id=cfee5ac8&scoped=true&"
import script from "./PlaceOrderPro.vue?vue&type=script&lang=js&"
export * from "./PlaceOrderPro.vue?vue&type=script&lang=js&"
import style0 from "./PlaceOrderPro.vue?vue&type=style&index=0&id=cfee5ac8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfee5ac8",
  null
  
)

export default component.exports